import qs from 'qs';
import IframeEventService from '@/services/IframeEventService';

export default {
  data() {
    return {
      iframeContent: null,
      isContentInsideIframe: false,
    };
  },
  methods: {
    checkThatAppInsideIframe() {
      return IframeEventService.isInsideIframe();
    },
    isInsideIframe() {
      try {
        const isInside = IframeEventService.isInsideIframe();
        this.iframeContent = isInside;
        if (isInside) {
          document.body.style.backgroundColor = '#fff';
        }
        return isInside;
      } catch (e) {
        return true;
      }
    },

    getQueryParameters() {
      return qs.parse(window.location.search.substring(1));
    },
  },
};
